export default __webpack_public_path__ + "static/media/fMaltoBuza26.4b5f528c.png";